import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Text, FlatList } from 'react-native';
import ActivityIndicator from '../components/ActivityIndicator';
import { ListItem } from '../components/lists';
import configurationPost from '../config/configurationPost';
import connectionConfig from "../config/settings";
import routes from '../navigation/routes';
import Button from "../components/Button";


function FollowedScreen(props) {
    useEffect(() => {       
        getFollowed()
    }, []);
const [items, setItems] = useState([])         // este es para obtener la lista de seguidos
const [loading, setLoading] = useState(false); // acciona el ActivityIndicator
const [followed, setFollowed] = useState(0);   // este hook es para validar si tiene seguidos el usuario 
const [follow, setFollow] = useState(0);       // este hook es para seguir al seguido por el usuario buscado 

//---------------------------------------------
//Va a servidor por la lista de seguidos
//---------------------------------------------
const getFollowed = async () => {
    setLoading(true)
    debugger
    var post_values = {
        userId : props.route.params.userIdListing
    }
   configurationPost.body = JSON.stringify(post_values)
   await fetch(connectionConfig.apiUrl+'/fixoUsers/SelectFollowed/', configurationPost)
   .then(response => response.json())
   .then(response => {
    setItems(response.data)
    
    if( response.data.length  ===  0 ){       
        setFollowed(1) 
    }

    setLoading(false)
   //console.log('select regresa', response)
   })
   .catch(err =>{
   console.log('Insert fixo failed :( review internet service', err )
   })
}
//--------------------------------------------------------
//método para seguir a los seguidos por usuario encontrado
//--------------------------------------------------------
const onPressFollow = async () => {
    var post_values = {
      userId : JSON.parse(user).userId , 
      followedId : listing.item.userId , 
      followerStatus : 1,
      datefollower : date,
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl+'/fixoUsers/insertFollower/', configurationPost)
    .then(response => response.json())
    .then(response => {
     // debugger
     // console.log('Insert regresa', response)

    })
    .catch(err =>{
      console.log('Insert fixo failed :( review internet service', err )
    })
  }  

   var profileUri =  connectionConfig.imageUrl +'/PerfilDeUsuario/'

    return (
        <View style={styles.container}>
            <ActivityIndicator visible={loading} />
            {followed ===  0 ?
                <FlatList
                  data={items}
                  keyExtractor={(items) => items.userId.toString()}                  
                  renderItem={({ item, index}) => (
                    <ListItem
                    image={profileUri + item.userId + '_' + item.userPhoto}
                    titleRol={item.userName}
                    // onPress1={ item.followedStatus === 1 ? onPressFollow : onPressFollow }
                    onPress={ () => {
                         props.navigation.navigate(routes.FOUND_USER, {item, index})
                         }}
                    >

                    </ListItem> 
                      
                  )}>
    
                </FlatList>
                
                :
                <Text>
                    This user has not followers             
                </Text>  
            }
        </View>
    );
}

const styles = StyleSheet.create({
    container:{
        flex: 1,
    }
})

export default FollowedScreen;